<template>
  <div class="superContract-userSurvey-page">
    <p class="hasBottomLine">用户概览-佣金情况</p>
    <!-- <div class="header-seach-box">
      <div class="inputWithSelectBox">
        <el-input placeholder="请输入币名称"  v-model="serchInfo.selectCoin" class="input-with-select">
          <el-button slot="append" disabled @click="getPageListInfo()" icon="el-icon-search">搜索</el-button>
        </el-input>
      </div>
    </div> -->
    <div class="table-box">
      <el-table :data="contractAccountListInfo" border style="width: 99.9%">
        <el-table-column prop="coinType" label="币种"> </el-table-column>
        <el-table-column prop="tradeFee" label="交易佣金"> </el-table-column>
        <el-table-column prop="profitFee" label="分润佣金"> </el-table-column>
        <el-table-column prop="maxDay" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="primary" @click="showListBtn(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer-box"></div>

    <el-dialog :title="currentInfo.coinType + ' -- 项目方分润'" :visible.sync="table">
     <el-table :data="profitDetail">
        <el-table-column prop="userId" label="用户Id"></el-table-column>
        <el-table-column prop="projectName" label="项目方名字"></el-table-column>
        <el-table-column prop="tradeFee" label="交易佣金"></el-table-column>
        <el-table-column prop="profitFee" label="分润佣金"></el-table-column>
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="pageChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="profitDetailTotal"
      >
      </el-pagination>
    </el-dialog>



  </div>
</template>

<script>
import "../store";
import api from "../api";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "userSurvey",
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      orderListDialog: false,
      borrowCoinParam: "",
      mortgageCoinParam: "",

      currentInfo: {},
      table: false,
      dialog: false,
      loading: false
    };
  },
  computed: {
    ...mapState("FinanceManage", ["contractAccountListInfo", "profitDetail", "profitDetailTotal"])
  },
  methods: {
    ...mapActions("FinanceManage", ["getContractAccountList", "getOrderProjectAccount"]),
    hanldSelectType() {
      this.serchInfo.selectCoin = "";
    },
    sizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    pageChange(val) {
      console.log(`当前页: ${val}`);
      this.getPageListInfo();
    },
    showListBtn(row) {
      let that = this;
      that.table = true;
      that.currentInfo = JSON.parse(JSON.stringify(row));

      this.getProfitDetail();

      // this.orderListDialog = true;
      // this.borrowCoinParam = row.borrowCoin;
      // this.mortgageCoinParam = row.mortgageCoin;
      // this.getPageListInfo();
    },

    getProfitDetail() {
      let that = this;
      let postData = {
        coinType: that.currentInfo.coinType,
        size: this.pageSize,
        page: this.currentPage
      };
      this.getOrderProjectAccount(postData);
    },

    getPageListInfo() {
      let postData = {
        page: this.currentPage,
        size: this.pageSize,
        borrowCoin: this.borrowCoinParam,
        mortgageCoin: this.mortgageCoinParam,
        status: 1
      };
      this.getOrderList(postData);
    },
    handleSearch() {},
    clearForm() {
      this.editDialog = false;
      this.preceptStatusDialog = false;
    },

    showDetailBtn(row) {
      this.toGoDetailPage(row.id);
    },
    toGoDetailPage(id) {
      this.$router.push("/home/finance/manage/mortgage/orderDetail?id=" + id);
    }
  },
  created() {},
  mounted() {
    this.getContractAccountList();
  }
};
</script>

<style lang="less">
.superContract-userSurvey-page {
  width: 100%;
  height: 500px;

  .hasBottomLine {
    width: 100%;
    padding-bottom: 18px;
    font-size: 18px;
    margin-bottom: 18px;
    font-weight: bold;
    border-bottom: 1px solid #cccccc;
  }

  .header-seach-box {
    width: 100%;
    margin-bottom: 30px;
    display: flex;

    .inputWithSelectBox {
      width: 500px;
      display: flex;

      .el-input-group__prepend {
        .el-select {
          width: 120px;
        }
      }

      .el-input-group__append {
        background: #409eff;
        color: #ffffff;
      }
    }

    .toTransLfet {
      margin-left: 30px;
    }

    .setSelect {
      margin-left: 30px;

      .el-select {
        margin-left: 12px;
      }
    }
  }

  .table-box {
    width: 100%;
    overflow: hidden;

    .el-table {
      .el-table__header-wrapper {
        .el-table__header {
          text-align: center;

          .cell {
            text-align: center;
          }
        }
      }

      .el-table__body-wrapper {
        .cell {
          text-align: center;
        }
      }
    }
  }

  .footer-box {
    padding: 20px 20px 50px 0px;
  }

  .configItem {
    margin-bottom: 50px;
    padding-bottom: 30px;
    border-bottom: 1px solid #cccccc;

    .item-title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 18px;
      display: flex;
      align-items: center;

      .el-button {
        margin-left: 50px;
      }
    }

    .item-action {
      display: flex;

      .desc-box {
        margin-right: 30px;

        .imitateInput {
          min-width: 60px;
          padding: 12px 20px;
          display: inline-block;
          text-align: center;
          border: 1px solid #cccccc;
          margin: 0 12px 0;
        }
      }

      .el-switch.is-disabled {
        opacity: 1;
      }

      .el-switch .is-disabled .el-switch__core,
      .el-switch.is-disabled .el-switch__label {
        cursor: pointer;
      }

      .el-switch.is-disabled .el-switch__core,
      .el-switch.is-disabled .el-switch__label {
        cursor: pointer;
      }
    }

    .item-remark {
      color: #ff8839;
      padding: 1px 0 22px 0;
    }
  }

  .bk-table-dialog {
    .el-dialog {
      width: 70%;

      .el-dialog__header {
        text-align: center;
        color: red;
      }

      .el-dialog__body {
        .el-table {
          .el-table__header-wrapper {
            .el-table__header {
              text-align: center;

              .cell {
                text-align: center;
              }
            }
          }

          .el-table__body-wrapper {
            .cell {
              text-align: center;
            }
          }
        }
      }

      .el-dialog__footer {
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
